import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    progress: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      height: '100vh',
    },
  },
  { name: 'Loader' },
);
